export const getDiseaseTextWithCode = disease => {
  return disease ? disease.id + ' ' + disease.vietnamese : '';
};
